export enum LEVEL {
  debug,
  info,
  warn,
  error,
}

export class GlobalError {
  statusCode: number;
  message: string;
  level: LEVEL;
  url?: string;

  constructor(statusCode: number, message: string, level: LEVEL) {
    this.statusCode = statusCode;
    this.message = message;
    this.level = level;
  }
}
